import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from '@mui/material/styles';

export const StyledDatePicker = styled(DatePicker)({
    "& .MuiTextField-root": {
        backgroundColor: "#181c20",
        margin: "14px"
    },
    "& .MuiFormControl-root-MuiTextField-root": {
        backgroundColor: "#181c20",
    },
    "& .MuiSvgIcon-root":
        { color: "rgba(255, 255, 255, 0.5)" },
    "& .MuiInputBase-root": {
        backgroundColor: "#181c20",
        color: "rgba(255, 255, 255, 0.875)",
        width: "100%"
    },
    "& .MuiInputBase-root:hover": {
        outline: "none",
        border: "none",
        borderColor: "rgba(255, 255, 255, 0.5)"
    },
    "& .MuiPaper-root": {
        padding: 2,
        marginTop: 1,
        backgroundColor: "rgba(120, 120, 120, 0.2)"
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none"
    }
});
